export const GET_MY_COUPONS_SUCCESS = 'GET_MY_COUPONS_SUCCESS';
export const LOADING_MESSAGE = 'Loading ...';
